export default __webpack_public_path__ + "static/media/like-heart.264f828b.svg";